import {
  FETCHING_USERS_REQUEST, FETCHING_USERS_SUCCEEDED, FETCHING_USERS_FAILED, INVALIDATE_USERS,
  UPDATE_USER_ACCESS_REQUEST, UPDATING_USER_ACCESS_SUCCEEDED, UPDATING_USER_ACCESS_FAILED,
  INVALIDATE_USER_ACCESS,
  
  INVITE_USER_REQUEST, INVITE_USER_SUCCEEDED, INVITE_USER_FAILED, INVALIDATE_INVITE_USER,
  FETCHING_INVITATIONS_REQUEST, FETCHING_INVITATIONS_SUCCEEDED, FETCHING_INVITATIONS_FAILED,
  RESEND_USER_INVITATION, RESEND_USER_INVITATION_SUCCEEDED, RESEND_USER_INVITATION_FAILED,
  DELETE_USER_INVITATION, DELETE_USER_INVITATION_SUCCEEDED, DELETE_USER_INVITATION_FAILED,
  UPDATE_INVITATION_ROLE, UPDATE_INVITATION_ROLE_SUCCEEDED, UPDATE_INVITATION_ROLE_FAILED,
  SET_STORYBOARD_USER_ROLE,
} from 'constants/actionTypes.jsx';

import _ from 'lodash';

const initialState = {
  users: {
    loading: false,
    invalidated: true,
    items: [],
    user: {
      update: null,
      access: null
    },
    pagination: {
      current: -1,
      totalPages: 1
    }
  },
  invitations: {
    loading: false,
    invalidated: true,
    items: [],
    invitation: {
      inviting: false,
      item: null,
      error: null,
      update: null,
      deletion: null,
      resend: null
    },
    pagination: {
      current: -1,
      totalPages: 1
    }
  }
}

function userManagementReducer(state = initialState, action) {
  switch (action.type) {
    case FETCHING_USERS_REQUEST: {
      return {
        ...state,
        users: {
          ...state.users,
          loading: true,
          invalidated: true,
        }
      }
    }

    case FETCHING_USERS_SUCCEEDED: {
      var records = action.payload.records;
      var items = [];

      if (action.payload.currentPage !== 0) {
        items = [...state.users.items, ...action.payload.records];
      } else {
        items = action.payload.records
      }

      items = _.uniqBy(items, 'id');

      return {
        ...state,
        users: {
          ...state.users,
          loading: false,
          error: false,
          invalidated: false,
          items: items,
          pagination: {
            ...state.users.pagination,
            current: action.payload.currentPage,
            totalPages: action.payload.totalPages,
            totalRecordsCount: action.payload.totalRecordsCount
          }
        }
      }
    }

    case FETCHING_USERS_FAILED: {
      return {
        ...state,
        users: {
          ...state.users,
          loading: false,
          invalidated: false,
          error: action.payload.errors,
          pagination: {
            current: -1,
            totalPages: 1
          }
        }
      }
    }

    case INVALIDATE_USERS: {
      return {
        ...state,
        users: {
          ...state.users,
          loading: false,
          invalidated: true,
          items: [],
          pagination: {
            current: -1,
            totalPages: 1
          }
        }
      }
    }

    case UPDATE_USER_ACCESS_REQUEST: {
      var { id } = action.payload;

      return {
        ...state,
        users: {
          ...state.users,
          user: {
            ...state.user,
            update: {
              id: id,
              updating: true,
              success: false,
              error: null
            }
          }
        }
      }
    }

    case UPDATING_USER_ACCESS_SUCCEEDED: {
      var { id, response } = action.payload;
      return {
        ...state,
        users: {
          ...state.users,
          items: state.users.items.map((user, index) => {
            if (user.id != id) {
              return user;
            }

            return {
              ...response
            };
          }),
          user: {
            ...state.user,
            update: {
              updating: false,
              success: true,
              error: null
            }
          }
        }
      }
    }

    case UPDATING_USER_ACCESS_FAILED: {
      var { id, error } = action.payload;

      return {
        ...state,
        users: {
          ...state.users,
          user: {
            ...state.user,
            update: {
              updating: false,
              success: false,
              error: error
            }
          }
        }
      }
    }

    case INVALIDATE_USER_ACCESS: {
      return {
        ...state,
        users: {
          ...state.users,
          user: {
            ...state.user,
            update: null
          }
        }
      }
    }

    case INVITE_USER_REQUEST: {
      return {
        ...state,
        invitations: {
          ...state.invitations,
          invitation: {
            ...state.invitation,
            inviting: true,
            error: null
          }
        }
      }
    }

    case INVITE_USER_SUCCEEDED: {
      var items = [];

      if (action.payload.entityType === 'user') {
        items = state.users.items.slice();
        items.splice(state.users.items.length, 0, action.payload);

        return {
          ...state,
          invitations: {
            ...state.invitations,
            invitation: {
              ...state.invitation,
              inviting: false,
              item: action.payload,
              error: null
            }
          },
          users: {
            ...state.users,
            items: items
          }
        }
      } else {
        items = state.invitations.items.slice();
        items.splice(state.invitations.items.length, 0, action.payload);

        return {
          ...state,
          invitations: {
            ...state.invitations,
            invitation: {
              ...state.invitation,
              inviting: false,
              item: action.payload,
              error: null
            },
            items: items
          }
        }
      }
    }

    case INVITE_USER_FAILED: {
      return {
        ...state,
        invitations: {
          ...state.invitations,
          invitation: {
            ...state.invitation,
            inviting: false,
            error: action.payload.errors
          }
        }
      }
    }

    case INVALIDATE_INVITE_USER: {
      return {
        ...state,
        invitations: {
          ...state.invitations,
          invitation: {
            ...state.invitation,
            inviting: false,
            item: null,
            error: null,
            deletion: null,
            resend: null
          }
        }
      }
    }

    case UPDATE_INVITATION_ROLE: {
      var { id } = action.payload;

      return {
        ...state,
        invitations: {
          ...state.invitations,
          update: {
            id: id,
            updating: true,
            success: false,
            error: null
          }
        }
      }
    }

    case UPDATE_INVITATION_ROLE_SUCCEEDED: {
      var { id, invitation } = action.payload;

      var invitations = state.invitations.items.map(item => {
        if (item.id === id) {
          return {
            ...item,
            ...invitation,
          }
        } else {
          return item;
        }
      })

      return {
        ...state,
        invitations: {
          ...state.invitations,
          items: invitations,
          invitation: {
            ...state.invitations.invitation,
            update: {
              ...state.invitations.invitation.update,
              success: true,
              error: null
            }
          }
        }
      }
    }

    case UPDATE_INVITATION_ROLE_FAILED: {
      var { id, error } = action.payload;

      return {
        ...state,
        invitations: {
          ...state.invitations,
          update: {
            id: id,
            updating: false,
            success: false,
            error: error
          }
        }
      }
    }

    case FETCHING_INVITATIONS_REQUEST: {
      return {
        ...state,
        invitations: {
          ...state.invitations,
          loading: true,
          invalidated: true,
        }
      }
    }

    case FETCHING_INVITATIONS_SUCCEEDED: {
      var records = action.payload.records;
      var items = [];

      records = records.map((item) => {
        return {
          ...item,
          resending: false,
          deleting: false
        }
      });

      if (action.payload.currentPage != 0) {
        items = [...state.invitations.items, ...action.payload.records];
      } else {
        items = action.payload.records
      }

      items = items.reduce((x, y) => {
        var index = x.findIndex((e) => {
          return e.id == y.id;
        });

        if (index < 0) {
          return [...x, y];
        } else {
          x[index] = y;
          return x;
        }

      }, []);

      return {
        ...state,
        invitations: {
          ...state.invitations,
          loading: false,
          invalidated: false,
          items: items,
          pagination: {
            ...state.users.pagination,
            current: action.payload.currentPage,
            totalPages: action.payload.totalPages
          }
        }
      }
    }

    case FETCHING_INVITATIONS_FAILED: {
      return {
        ...state,
        invitations: {
          ...state.invitations,
          loading: false,
          invalidated: false,
          error: action.payload.error,
          pagination: {
            current: -1,
            totalPages: 1
          }
        }
      }
    }

    case RESEND_USER_INVITATION: {
      var {id} = action.payload;

      var invitations = state.invitations.items.map(invitation => {
        if (invitation.id == id) {
          return {
            ...invitation,
            resending: true
          }
        } else {
          return invitation;
        }
      })
      return {
        ...state,
        invitations: {
          ...state.invitations,
          items: invitations
        }
      }
    }

    case RESEND_USER_INVITATION_SUCCEEDED: {
      var invitationId = action.payload;

      var invitations = state.invitations.items.map(invitation => {
        if (invitation.id == invitationId) {
          return {
            ...invitation,
            resending: false

          }
        } else {
          return invitation;
        }
      })
      return {
        ...state,
        invitations: {
          ...state.invitations,
          items: invitations,
          invitation: {
            ...state.invitations.invitation,
            resend: {
              success: true
            }
          }
        }
      }
    }

    case RESEND_USER_INVITATION_FAILED: {
      var {id, error} = action.payload;

      var invitations = state.invitations.items.map(invitation => {
        if (invitation.id == id) {
          return {
            ...invitation,
            resending: false

          }
        } else {
          return invitation;
        }
      });

      return {
        ...state,
        invitations: {
          ...state.invitations,
          items: invitations,
          invitation: {
            ...state.invitations.invitation,
            resend: {
              success: false,
              error: error
            }
          }
        }
      }
    }


    case DELETE_USER_INVITATION: {
      var invitationId = action.payload.id;

      var invitations = state.invitations.items.map(invitation => {
        if (invitation.id === invitationId) {
          return {
            ...invitation,
            deleting: true
          }
        } else {
          return invitation;
        }
      })

      return Object.assign({}, state, {
        ...state,
        invitations: {
          ...state.invitations,
          items: invitations
        }
      })
    }

    case DELETE_USER_INVITATION_SUCCEEDED: {
      var id = action.payload;

      return Object.assign({}, state, {
        ...state,
        invitations: {
          ...state.invitations,
          items: state.invitations.items.filter((user, index) => {
            return user.id != id;
          }),
          invitation: {
            ...state.invitations.invitation,
            deletion: {
              success: true
            }
          }
        }
      })
    }

    case DELETE_USER_INVITATION_FAILED: {
      return Object.assign({}, state, {
        ...state,
        invitations: {
          ...state.invitations,
          deletion: {
            success: false,
            error: action.payload
          }
        }
      })
    }

    case SET_STORYBOARD_USER_ROLE: {
      const { userId, role } = action.payload;

      var users = state.users.items.map(user => {
        if(user.id === userId) {
          return {
            ...user,
            edited: true,
            role: role
          }
        } else {
          return user;
        }
      })

      return {
        ...state,
        users: {
          ...state.users,
          items: users
        }
      }
    }

    default:
      return state
  }
}

export { userManagementReducer };